(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue-cropper", [], factory);
	else if(typeof exports === 'object')
		exports["vue-cropper"] = factory();
	else
		root["vue-cropper"] = factory();
})(self, () => {
return 